<template lang="pug">
.register-row
  .register-group
    .register-key
      span.key-name 介護度
      slot(name="keyName")
      span.validation-label(v-if="required == true") 必須
      slot(name="question")

    .register-value
      .d-flex.flex-column
        .d-flex.flex-row.flex-wrap.mb-1
          .radio
            label.register-radio-label
              input.register-radio-form(v-model="_value" type="radio" :name="name" :value="'careLevel1000'"
                v-validate="validationRules" :data-vv-as="(validationKeyName) ? validationKeyName : '介護度'")
              span.register-radio-text 自立
          .radio
            label.register-radio-label
              input.register-radio-form(v-model="_value" type="radio" :name="name" :value="'careLevel1010'")
              span.register-radio-text 申請中
        .d-flex.flex-row.flex-wrap.mb-1
          .radio
            label.register-radio-label
              input.register-radio-form(v-model="_value" type="radio" :name="name" :value="'careLevel2010'")
              span.register-radio-text 要支援１
          .radio
            label.register-radio-label
              input.register-radio-form(v-model="_value" type="radio" :name="name" :value="'careLevel2020'")
              span.register-radio-text 要支援２
        .d-flex.flex-row.flex-wrap.mb-1
          .radio
            label.register-radio-label
              input.register-radio-form(v-model="_value" type="radio" :name="name" :value="'careLevel3010'")
              span.register-radio-text 要介護１
          .radio
            label.register-radio-label
              input.register-radio-form(v-model="_value" type="radio" :name="name" :value="'careLevel3020'")
              span.register-radio-text 要介護２
          .radio
            label.register-radio-label
              input.register-radio-form(v-model="_value" type="radio" :name="name" :value="'careLevel3030'")
              span.register-radio-text 要介護３
          .radio
            label.register-radio-label
              input.register-radio-form(v-model="_value" type="radio" :name="name" :value="'careLevel3040'")
              span.register-radio-text 要介護４
          .radio
            label.register-radio-label
              input.register-radio-form(v-model="_value" type="radio" :name="name" :value="'careLevel3050'")
              span.register-radio-text 要介護５

    .error-messages(v-for="error in errors.collect(name)")
      label.error-message {{ error }}
      br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

@Component
export default class FormInputCarelevels extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: string;

  /** 必須か */
  @Prop({
    default: () => {
      return false;
    },
    type: Boolean
  })
  required!: boolean;

  /** name属性の値 */
  @Prop({ required: true, type: String })
  name!: string;

  /** veevalidateに渡すバリデーションルール */
  @Prop()
  validationRules!: string;

  /** veevalidateに渡すバリデーション項目名 */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  validationKeyName!: string;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): string {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: string) {
    this.$emit("input", newValue);
    return;
  }
}
</script>
